import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Navigate } from 'react-router-dom';

import ForwardAddresses from '../components/institute/ForwardAddresses';
import InstituteDetails from '../components/institute/InstituteDetails';

import {
  showNotification,
  showErrorNotification,
} from '../redux/actions';
import ApiClient from '../loopback/apiClient';
import { RootState, QuipUserWithInstitute, Institute } from '../redux/types';

type State = {
  quipuser?: QuipUserWithInstitute;
}

class InstituteView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.fetchQuipUserWithInstitute();
  }

  fetchQuipUserWithInstitute = async () => {
    const { userId } = this.props;
    const quipuser = await ApiClient.getUserWithInstitute(Number(userId));
    this.setState({ quipuser });
  };

  renderInstituteDetails = (institute: Institute) => {
    const {
      locale,
      showNotification: showNotificationAction,
    } = this.props;
    return (
      <InstituteDetails
        institute={institute}
        onChange={this.fetchQuipUserWithInstitute}
        updateInstitute={ApiClient.updateInstitute}
        addInstitute={ApiClient.addInstituteFirstTime}
        showNotification={showNotificationAction}
        locale={locale}
      />
    );
  };

  renderForwardAddresses = (institute: Institute) => {
    const {
      showNotification: showNotificationAction,
      showErrorNotification: showErrorNotificationAction,
    } = this.props;
    return (
      institute && (
        <ForwardAddresses
          addresses={institute?.forwardAddresses || []}
          onSave={(data: string[]) => {
            ApiClient.updateInstitute({
              ...institute,
              forwardAddresses: data,
            })
              .then(() => showNotificationAction(<FormattedMessage id="genericSaveMessage" />))
              .catch(() => showErrorNotificationAction(<FormattedMessage id="genericErrorMessage" />));
          }}
        />
      )
    );
  };

  render() {
    const {
      userId,
    } = this.props;
    const {
      quipuser,
    } = this.state;
    if (!userId) {
      return <Navigate to="/login" />;
    }

    return (
      <>
        {
          quipuser && (
            <div>
              {this.renderInstituteDetails(quipuser.institute)}
              {this.renderForwardAddresses(quipuser.institute)}
            </div>
          )

        }
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  userId: state.users?.token?.userId,
  locale: state.intl.locale,
});

const dispatchProps = {
  showNotification,
  showErrorNotification,
};

const connector = connect(mapStateToProps, dispatchProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;
export default connector(InstituteView);
